import style from './style';
const { rootViewStyle, arrowPicEleStyle, guidePicEleStyle } = style;
const getDomTree = function (viewInstance) {
    const vDom = {
        domKey: 'rootView',
        tag: 'div',
        props: { class: 'launch-app-user-guid-view' },
        style: rootViewStyle,
        events: { click: () => viewInstance.removeUI('rootView') },
        children: [
            {
                domKey: 'arrowPicEle',
                tag: 'img',
                props: { src: 'https://ut-static.udache.com/webx/ut/fHqLDgx0WtEo4FiWRmnFK.png' },
                style: arrowPicEleStyle,
            },
            {
                domKey: 'guidePicEle',
                tag: 'img',
                props: { src: 'https://ut-static.udache.com/webx/ut/MfcLieAwgRx-n_D-JpPet.png' },
                style: guidePicEleStyle,
            }
        ]
    };
    return vDom;
};
export default getDomTree;
